import { createAction } from "typesafe-actions";
export var set = createAction("user/SET", function (resolve) {
  return function (newState) {
    return resolve(newState);
  };
});
export var setToken = createAction("user/SET_ACCESS_TOKEN", function (resolve) {
  return function (accessToken) {
    return resolve(accessToken);
  };
});
export var setQuizState = createAction("user/SET_USER_QUIZ_STATE", function (resolve) {
  return function (payload) {
    return resolve(payload);
  };
});
export var setUserQuizState = function setUserQuizState(userQuizState) {
  return function (dispatch, getState) {
    dispatch(setQuizState({
      quiz: getState().quiz,
      quizAnswer: getState().quizAnswer.quizAnswer,
      userQuizState: userQuizState
    }));
  };
};
export var clear = createAction("user/CLEAR");